var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInjury(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "red-cross 1",
    clipPath: "url(#clip0_68_24001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60 30C60 13.4314 46.5686 0 30 0V60C46.5686 60 60 46.5686 60 30Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.6709 23.4581H37.1778C36.8463 23.4581 36.5776 23.1894 36.5776 22.8578V14.3648C36.5776 12.9594 35.4383 11.8201 34.0329 11.8201H26.0821C24.6767 11.8201 23.5374 12.9594 23.5374 14.3648V22.8578C23.5374 23.1894 23.2687 23.4581 22.9372 23.4581H14.4441C13.0387 23.4581 11.8994 24.5974 11.8994 26.0028V33.9535C11.8994 35.3589 13.0387 36.4982 14.4441 36.4982H22.9372C23.2687 36.4982 23.5374 36.7669 23.5374 37.0985V45.5915C23.5374 46.9969 24.6767 48.1362 26.0821 48.1362H34.0329C35.4383 48.1362 36.5776 46.9969 36.5776 45.5915V37.0985C36.5776 36.7669 36.8463 36.4982 37.1778 36.4982H45.6709C47.0763 36.4982 48.2156 35.3589 48.2156 33.9535V26.0028C48.2156 24.5974 47.0763 23.4581 45.6709 23.4581Z",
    fill: "#FF405C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.671 23.4581H37.178C36.8464 23.4581 36.5777 23.1894 36.5777 22.8578V14.3648C36.5777 12.9594 35.4384 11.8201 34.033 11.8201H30V48.1364H34.033C35.4384 48.1364 36.5777 46.9971 36.5777 45.5916V37.0986C36.5777 36.7671 36.8464 36.4984 37.178 36.4984H45.671C47.0764 36.4984 48.2157 35.3591 48.2157 33.9536V26.0029C48.2157 24.5974 47.0764 23.4581 45.671 23.4581Z",
    fill: "#E20059"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_24001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjury);
export default __webpack_public_path__ + "static/media/injury.ad1b74527c3a4b99bbc187c572c8dee6.svg";
export { ForwardRef as ReactComponent };